import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/28a02ba018e540cb808856dcffc9a7b1/1d29588582cc4ce2185161fe660b749c.png"
            alt="Dolar Hoy Venezuela"
            className="h-14 w-auto object-contain"
          />
        </a>
        <a
          href="https://remesasve.com"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="hidden md:inline-flex items-center gap-2 text-base font-bold text-white bg-green-600 rounded-full px-7 py-3 hover:bg-green-500 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-green-500/30 hover:scale-105 active:scale-95"
        >
          Enviar dinero
        </a>
      </div>
    </nav>
  );
}
